import {
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from './registru.service';
import { Observable, finalize, map } from 'rxjs';
import { GenericWithSlug } from 'src/app/interfaces/generic.interface';
import { AddRegistruComponent } from './add-registru/add-registru.component';
import Swal from 'sweetalert2';
import { PermissionsService } from '../../services/permissions.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { FormControl, FormGroup } from "@angular/forms";
import { AcordFunctionareComponent } from './tabele-registru/acord-functionare/acord-functionare.component';
import { ToateTabelRegistruComponent } from './tabele-registru/toate-tabel-registru/toate-tabel-registru.component';
import { AcordTemporarComponent } from './tabele-registru/acord-temporar/acord-temporar.component';
import { AutorizatieAlimentatiePublicaComponent } from './tabele-registru/autorizatie-alimentatie-publica/autorizatie-alimentatie-publica.component';
import { AutorizatiePiataComponent } from './tabele-registru/autorizatie-piata/autorizatie-piata.component';
import { AutorizatieRecreativeComponent } from './tabele-registru/autorizatie-recreative/autorizatie-recreative.component';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AcordComercializareComponent } from './tabele-registru/acord-comercializare/acord-comercializare.component';
import { AcordTeraseSezoniereComponent } from './tabele-registru/acord-terase-sezoniere/acord-terase-sezoniere.component';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: "app-registru",
    templateUrl: "./registru.component.html",
    styleUrls: ["./registru.component.scss"],
})
export class RegistruComponent implements OnInit {
    @ViewChild(AcordComercializareComponent) appAcordComercializare!: AcordComercializareComponent;
    @ViewChild(AcordFunctionareComponent) appAcordFunctionare!: AcordFunctionareComponent;
    @ViewChild(AcordTemporarComponent) appAcordTemporar!: AcordTemporarComponent;
    @ViewChild(AcordTeraseSezoniereComponent) appAcordTeraseSezoniere!: AcordTeraseSezoniereComponent;
    @ViewChild(AutorizatieAlimentatiePublicaComponent) appAutorizatieAlimentatiePublica!: AutorizatieAlimentatiePublicaComponent;
    @ViewChild(AutorizatiePiataComponent) appAutorizatiePiata!: AutorizatiePiataComponent;
    @ViewChild(AutorizatieRecreativeComponent) appAutorizatieRecreative!: AutorizatieRecreativeComponent;
    @ViewChild(ToateTabelRegistruComponent) appToateTabelRegistru!: ToateTabelRegistruComponent;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    showCard = false;
    searchParamsForm!: FormGroup;
    dataTableParams: any = {};
    fullDataTableParams: any = {};

    isLoading = false;
    defaultParameter: { id: string; name: string; slug: string; } = {
        id: "-1",
        name: "Toate",
        slug: "toate"
    };

    // Info for conditional assign and change status from DT
    selectedTabelBorderouSlug: string = 'toate';

    registre$!: Observable<GenericWithSlug[]>;

    registru_id: number = -1;
    // List of ids on which we render the Add button

    // allowedRegistruIds = [-1, 1, 3, 4, 7];
    // selectedRegistruId!: number;

    registru_slug: string = '';

    allowedRegistreSlugs = [
        'acord-de-functionare', // 1
        'acord-temporar', // 3
        'autorizatie-alimentatie-publica', // 2
        'autorizatie-piata-targ', // 4
        'autorizatie-recreative', // 5
        'acord-comercializare', // 1 - ca la functionare ??
        'acord-terase-sezoniere', // 6
    ];

    isAllowedToShowAddDialog(): boolean {
        return (
            this.allowedRegistreSlugs.includes(this.registru_slug)
        );
    }

    initialFormValues = {
        acord: '',
        numarCerere: '',
        CAEN: '',
        agentEconomic: '',
        cuiFirma: '',
        valabilityCheck: -1,
        punct_lucru: false,
        pl_strada: '',
        pl_numar: '',
        pl_bloc: '',
        pl_scara: '',
        pl_etaj: '',
        pl_apartament: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            acord: new FormControl(""),
            numarCerere: new FormControl(""),
            CAEN: new FormControl(""),
            agentEconomic: new FormControl(""),
            cuiFirma: new FormControl(""),
            valabilityCheck: new FormControl(-1),
            punct_lucru: new FormControl(false),
            pl_strada: new FormControl(""),
            pl_numar: new FormControl(""),
            pl_bloc: new FormControl(""),
            pl_scara: new FormControl(""),
            pl_etaj: new FormControl(""),
            pl_apartament: new FormControl(""),
        });
    }

    updateDataTableParams() {
        this.dataTableParams.filters = this.searchParamsForm.value;
        this.dataTableParams.tip_date = +this.dateFilterOption;
        this.dataTableParams.date_from = this.formatDate(this.selectedStartDate);
        this.dataTableParams.date_to = this.formatDate(this.selectedEndDate);
    }

    updateCurrentDataTable() {
        this.updateDataTableParams();
        this.rerenderChildDT(this.registru_slug, true)
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }

    applyFilters(): void {
        this.showCard = false;
        this.updateCurrentDataTable();
    }
    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.updateCurrentDataTable();
        this.showCard = true;
    }
    toggleCard() {
        this.showCard = !this.showCard;
    }

    // Popover dates
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    @ViewChild("startCalendar") startCalendar!: MatCalendar<Date>;
    @ViewChild("endCalendar") endCalendar!: MatCalendar<Date>;
    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = "current_year";
    dateFilterOption: number = 1;

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.updateCurrentDataTable();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = new Date(year, 11, 31); // 31 Decembrie
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.updateCurrentDataTable();
        this.selectedFilteringButton =
            yearsBack === 0 ? "current_year" : "previous_year";
    }

    calendarYears: number[] = [2019, 2020, 2021, 2022, 2023, 2024, 2025]

    setSpecificYear(year: number): void {
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = new Date(year, 11, 31); // 31 Decembrie
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.updateCurrentDataTable();
        this.selectedFilteringButton = year.toString();
    }

    setAllYears(): void {
        this.selectedStartDate = new Date(this.calendarYears[0], 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = new Date(this.calendarYears[this.calendarYears.length - 1], 11, 31); // 31 Decembrie
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.updateCurrentDataTable();
        this.selectedFilteringButton = 'all_years';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    onDateFilterChange(): void {
        this.updateCurrentDataTable();
    }

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: "Adăugare" },
        { id: 2, value: "Actualizare" }, // Anulare
        { id: 3, value: "Validare" }, // Ultima actualizare
        { id: 4, value: "Invalidare/Anulare" }, // Eliberare
        { id: 5, value: "Finalizare" }, // Retragere
        // { id: 6, value: "Avizare" },
    ];

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.listDT;

    constructor(
        private dialog: MatDialog,
        private dialogService: DialogService,
        private registruService: RegistruService,
        private permissionsService: PermissionsService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.loadRegistre();
        this.buildSearchParamsForm();
        this.updateDataTableParams();
    }

    loadRegistre() {
        this.registre$ = this.registruService
            .getRegistreActive()
            .pipe(map((results: any) => [this.defaultParameter, ...results]));
    }

    onTableChange(event: MatButtonToggleChange) {
        this.selectedTabelBorderouSlug = event.value;
        this.registru_slug = event.value;

        switch (this.selectedTabelBorderouSlug) {
            case 'acord-de-functionare':
                this.registru_id = 1;
                break;
            case 'acord-comercializare':
                this.registru_id = 1;   // Ca la functionare ??
                break;
            case 'acord-temporar':
                this.registru_id = 3;
                break;
            case 'autorizatie-alimentatie-publica':
                this.registru_id = 2;  // 4 ????
                break;
            case 'autorizatie-piata-targ':
                this.registru_id = 4;  // 7 ???
                break;
            case 'autorizatie-recreative':
                this.registru_id = 5;
                break;
            case 'acord-terase-sezoniere':
                this.registru_id = 6;
                break;
            default:
                this.registru_id = -1;
                break;
        }
    }

    rerenderChildDT(registruSlug: string, paginate = false) {
        switch (registruSlug) {
            case 'acord-de-functionare':
                this.appAcordFunctionare.rerenderDT(paginate);
                break;
            case 'acord-comercializare':
                this.appAcordComercializare.rerenderDT(paginate);
                break;
            case 'acord-temporar':
                this.appAcordTemporar.rerenderDT(paginate);
                break;
            case 'autorizatie-alimentatie-publica':
                this.appAutorizatieAlimentatiePublica.rerenderDT(paginate);
                break;
            case 'autorizatie-piata-targ':
                this.appAutorizatiePiata.rerenderDT(paginate);
                break;
            case 'autorizatie-recreative':
                this.appAutorizatieRecreative.rerenderDT(paginate);
                break;
            case 'acord-terase-sezoniere':
                this.appAcordTeraseSezoniere.rerenderDT(paginate);
                break;
            default:
                this.appToateTabelRegistru.rerenderDT(paginate);
                break;
        }
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddRegistruComponent, {
            maxHeight: '80vh',
            minWidth: '50vw',
            maxWidth: '80vw',
            data: {
                registru_id: this.registru_id,
                registru_slug: this.registru_slug
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Registru adăugat cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
                this.isLoading = false;

            }
        });
    }

    onDataTableChange(params: any) {
        this.fullDataTableParams = params;
    }

    exportRegisterCSV() {
        if (this.fullDataTableParams) {
            this.isLoading = true;

            this.registruService.exportRegistruCSV(this.fullDataTableParams)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe({
                    next: (response: any) => {
                        let dataType = response.type;
                        let binaryData = [];
                        binaryData.push(response);
                        let downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                        downloadLink.setAttribute('target', '_blank');
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    },
                    error: (err) => {
                        let msg;
                        try {
                            // try to catch the message from server
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            // controll output message
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    },
                });
        }
    }
}
